<script>
import { mapState } from 'vuex';

import i18n from '../i18n';
import store from '../store';
import { DEV_GRAPH_URL } from '../env';

export default {
  i18n,
  store,
  name: 'ApiLogs',
  components: {},
  props: [],
  data: () => ({
    loading: false,
    error: null,
  }),
  computed: {
    ...mapState(['apikey']),
    downloadUrl() {
      return new URL(`/graphql/api/logs?apiKey=${this.apikey}`, DEV_GRAPH_URL || window.location.origin);
    },
  },
  methods: {},
};
</script>

<template>
  <div class="whitespace-normal flex flex-col gap-y-6">
    <span class="leading-8 max-w-3xl">
      The primary method of support for Unraid Connect is through <a href="https://forums.unraid.net/forum/94-connect-plugin-support/" target="_blank" rel="noopener noreferrer">our forums</a> and <a href="https://discord.gg/unraid" target="_blank" rel="noopener noreferrer">Discord</a>. If you are asked to supply logs, please open a support request on our <a href="https://unraid.net/contact" target="_blank" rel="noopener noreferrer">Contact Page</a> and reply to the email message you receive with your logs attached. The logs may contain sensitive information so do not post them publicly.
    </span>
    <span>
      <a
        :href="downloadUrl"
        rel="noopener noreferrer"
        class="button flex-none"
        target="_blank"
        download
      >
        {{ $t('download') }}
      </a>
    </span>
    <span v-if="error" class="text-red max-w-2xl"><em>{{ error }}</em></span>
  </div>
</template>

<style lang="postcss" scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;

a {
  color: #486dba;
}

a:hover,
a:focus {
  @apply underline;
}

.button {
  font-family: clear-sans;
  font-size: 1.1rem;
  font-weight: bold;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  min-width: 86px;
  margin: 0 12px 10px 0;
  padding: 8px;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  border-radius: 4px;
  border: none;
  color: #ff8c2f;
  background: -webkit-gradient(linear,left top,right top,from(#e22828),to(#ff8c2f)) 0 0 no-repeat,-webkit-gradient(linear,left top,right top,from(#e22828),to(#ff8c2f)) 0 100% no-repeat,-webkit-gradient(linear,left bottom,left top,from(#e22828),to(#e22828)) 0 100% no-repeat,-webkit-gradient(linear,left bottom,left top,from(#ff8c2f),to(#ff8c2f)) 100% 100% no-repeat;
  background: linear-gradient(90deg,#e22828 0,#ff8c2f) 0 0 no-repeat,linear-gradient(90deg,#e22828 0,#ff8c2f) 0 100% no-repeat,linear-gradient(0deg,#e22828 0,#e22828) 0 100% no-repeat,linear-gradient(0deg,#ff8c2f 0,#ff8c2f) 100% 100% no-repeat;
  background-size: 100% 2px,100% 2px,2px 100%,2px 100%;
}
.button:hover,
.button:hover[type="button"] {
  color: #f2f2f2;
  text-decoration: none;
  background: -webkit-gradient(linear,left top,right top,from(#e22828),to(#ff8c2f));
  background: linear-gradient(90deg,#e22828 0,#ff8c2f);
}

/*! purgecss start ignore */
.fade-enter-active, .fade-leave-active {
  transition: opacity .15s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
@media (prefers-reduced-motion) {
  * { transition-duration: 0 !important }
}

[v-cloak] { display: none }
/*! purgecss end ignore */
</style>
